<template>
  <div class="group-md group-middle">
    <span class="social-title">{{ $t ? $t("Share") : "Share" }}</span>
    <div>
      <ul class="list-inline list-inline-sm social-list">
        <li>
          <a
            class="icon fa fa-whatsapp"
            :href="whatsappUrl"
            target="_blank"
            rel="noopener noreferrer"
            @click.prevent="share('whatsapp')"
            title="Compartir en WhatsApp"
          ></a>
        </li>
        <li>
          <a
            class="icon fa fa-facebook"
            :href="facebookUrl"
            target="_blank"
            rel="noopener noreferrer"
            @click.prevent="share('facebook')"
            title="Compartir en Facebook"
          ></a>
        </li>
        <li>
          <!--
            Font Awesome no tiene "fa-x". Usa fa-twitter (FA4/FA5) o fa-x-twitter (FA6).
            Ajusta la clase según tu versión de FA:
              - FA 4/5: fa fa-twitter
              - FA 6:   fa-brands fa-x-twitter
          -->
          <a
            class="icon fa fa-twitter"
            :href="twitterUrl"
            target="_blank"
            rel="noopener noreferrer"
            @click.prevent="share('twitter')"
            title="Compartir en X (Twitter)"
          ></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "SocialShare",

  props: {
    // URL a compartir. Si no se pasa, usa la URL actual del navegador
    url: {
      type: String,
      default: null,
    },
    // Texto opcional para acompañar el enlace (X/Twitter y WhatsApp)
    text: {
      type: String,
      default: "",
    },
  },

  computed: {
    shareUrl() {
      return (
        this.url || (typeof window !== "undefined" ? window.location.href : "")
      );
    },

    encodedUrl() {
      return encodeURIComponent(this.shareUrl);
    },

    encodedText() {
      return encodeURIComponent(this.text);
    },

    facebookUrl() {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.encodedUrl}`;
    },

    // X (Twitter) — x.com/intent/tweet funciona igual que twitter.com
    twitterUrl() {
      const base = "https://x.com/intent/tweet";
      return this.text
        ? `${base}?text=${this.encodedText}&url=${this.encodedUrl}`
        : `${base}?url=${this.encodedUrl}`;
    },

    // WhatsApp — abre la app en móvil o WhatsApp Web en desktop
    whatsappUrl() {
      const message = this.text
        ? `${this.encodedText}%20${this.encodedUrl}`
        : this.encodedUrl;
      return `https://api.whatsapp.com/send?text=${message}`;
    },

    // Instagram no tiene API de compartir directa por URL
    instagramUrl() {
      return "https://www.instagram.com/";
    },
  },

  methods: {
    share(network) {
      const width = 600;
      const height = 500;
      const left = window.screen.width / 2 - width / 2;
      const top = window.screen.height / 2 - height / 2;
      const popup = `width=${width},height=${height},top=${top},left=${left},toolbar=no,menubar=no`;

      switch (network) {
        case "facebook":
          window.open(this.facebookUrl, "facebook-share", popup);
          break;

        case "twitter":
          window.open(this.twitterUrl, "twitter-share", popup);
          break;

        case "whatsapp":
          // En móvil abre la app; en desktop abre WhatsApp Web
          window.open(this.whatsappUrl, "whatsapp-share", popup);
          break;

        case "instagram":
          // Instagram no permite compartir por URL externa → copiamos al portapapeles
          this.copyToClipboard(this.shareUrl);
          return;
      }

      this.$emit("shared", { network, url: this.shareUrl });
    },

    copyToClipboard(text) {
      const onSuccess = () => {
        this.$emit("copied", text);
        this.$emit("shared", { network: "instagram", url: text });
        alert("Enlace copiado al portapapeles. ¡Pégalo en Instagram!");
      };

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(text)
          .then(onSuccess)
          .catch(console.error);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.cssText = "position:fixed;opacity:0";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
          document.execCommand("copy");
          onSuccess();
        } catch (err) {
          console.error("No se pudo copiar el enlace:", err);
        }
        document.body.removeChild(textarea);
      }
    },
  },
};
</script>
